import { Module, mapState } from 'vuex'
import { GetterTree, ActionTree, MutationTree } from 'vuex'
import { RootState } from '../types'
import sysLocalStorage, { enStorageName } from '../localStorage'
import { getCommonData } from '@/api/common/select'

export interface DataSourceState {
  pagePath: string,
  dataSource: any,
  dateSelector: any[],
  cruiseLevel: any[],//巡查任务主体 1本级 2下级
  cruiseTeamTypes: any[],//巡查主体 1巡防组织 2本级机构
  cityList: any[],
  unitLevel: any[],
  unitClassify: any[]
}

export const state: DataSourceState = {
  pagePath: '',
  dataSource: null,
  dateSelector: [],
  cruiseLevel: [],
  cruiseTeamTypes: [],
  cityList: [],
  unitLevel: [],
  unitClassify: []
}

const mutations: MutationTree<DataSourceState> = {
  SET_PAGEPATH: (mState: DataSourceState, path: string) => {
    mState.pagePath = path
  },
  SET_DATASOURCE: (mState: DataSourceState, data: any) => {
    mState.dataSource = data
  },
  /*
  SET_DATESELECTOR: (mState: DataSourceState, data: any[]) => {
    mState.dateSelector = data
  },
  SET_UNITLEVEL: (mState: DataSourceState, data: any[]) => {
    mState.unitLevel = data
  },
  SET_UNITCLASSIFY: (mState: DataSourceState, data: any[]) => {
    mState.unitClassify = data
  },
  SET_CITYCOUNTY: (mState: DataSourceState, data: any[]) => {
    mState.cityList = data
  },
  SET_CRUISELEVEL: (mState: DataSourceState, data: any[]) => {
    mState.cruiseLevel = data
  },
  SET_CRUISETEAMTYPES: (mState: DataSourceState, data: any[]) => {
    mState.cruiseTeamTypes = data
  },*/
  SET_COMMONDATA: (mState: DataSourceState, data: any) => {
    mState.dateSelector = data.dateSelector
    mState.unitLevel = data.unitLevel
    mState.unitClassify = data.unitClassify
    mState.cityList = data.cityList
    mState.cruiseLevel = data.cruiseLevel
    mState.cruiseTeamTypes = data.cruiseTeamTypes
  }
}

const snCommonData = enStorageName[enStorageName.CommonData]// 'CommonDataSource'
const actions: ActionTree<any, RootState> = {
  SetPageData({ commit }, data: any) {
    commit('SET_DATASOURCE', data)
  },
  SetCommonData({ commit }) {
    //日期查询控件的数据源，系统第一次登陆后加载，后续不需要在加载
    var storageData = sysLocalStorage.getItem(snCommonData)
    if (storageData) {
      var d = JSON.parse(storageData)
      commit('SET_COMMONDATA', d)
    } else {
      getCommonData().then((response: { data: any }) => {
        const data = response.data
        if (data) {
          sysLocalStorage.setItem(snCommonData, JSON.stringify(data))
          commit('SET_COMMONDATA', data)
        }
      }).catch((error: any) => {
        console.log('getCommonData error', error)
        sysLocalStorage.removeItem(snCommonData)
        return null
      })
    }
  }
}
const getters: GetterTree<any, RootState> = {
  pagePath: mState => mState.pagePath,
  dataSource: mState => mState.dataSource,
  dateSelector: mState => mState.dateSelector,
  cityList: mState => mState.cityList,
  unitLevel: mState => mState.unitLevel,
  unitClassify: mState => mState.unitClassify,
  cruiseLevel: mState => mState.cruiseLevel,
  cruiseTeamTypes: mState => mState.cruiseTeamTypes
}

const namespaced: boolean = true;

export const dataSource: Module<any, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
